import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=a681317a&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=ts"
export * from "./CartFooter.vue?vue&type=script&lang=ts"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=a681317a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a681317a",
  null
  
)

export default component.exports